// employee constants
import {
  RESET_ASSIGN_CUSTOMER_ACCOUNT_MANAGER,
  ASSIGN_CUSTOMER_ACCOUNT_MANAGER,
  ASSIGN_CUSTOMER_ACCOUNT_MANAGER_SUCCESS,
  ASSIGN_CUSTOMER_ACCOUNT_MANAGER_FAILURE,
} from "../../constants/Customers/AssignCustomerAccountManager";

const INIT_STATE = {
  assignCustomerAccountManager: {},
  loadingAssignCustomerAccountManager: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_ASSIGN_CUSTOMER_ACCOUNT_MANAGER:
      return INIT_STATE;

    case ASSIGN_CUSTOMER_ACCOUNT_MANAGER:
      return {
        ...state,
        loadingAssignCustomerAccountManager: true,
      };
    case ASSIGN_CUSTOMER_ACCOUNT_MANAGER_SUCCESS:
      return {
        ...state,
        loadingAssignCustomerAccountManager: false,
        assignCustomerAccountManager: action.payload,
      };
    // eslint-disable-next-line no-fallthrough
    case ASSIGN_CUSTOMER_ACCOUNT_MANAGER_FAILURE:
      return {
        ...state,
        loadingAssignCustomerAccountManager: false,
        assignCustomerAccountManager: "Error in  getting Club Data",
      };
    default:
      return state;
  }
};
